import { queryOptions, useQuery } from "@tanstack/react-query";

import data from "../../assets/mocks/watchlists.json";

import { api } from "@/lib/api-client";
import { hasAccessToken } from "@/lib/auth";
import { AxiosMock } from "@/utils/mock";

import type { QueryConfig } from "@/lib/react-query";
import type { Watchlist } from "@/types/watchlist";

if (import.meta.env.MODE === "test") {
  // Mocking the API response for watchlists
  const mock = AxiosMock.getInstance();
  data.forEach((watchlist) => {
    mock.onGet(`/carburate/watchlists/${watchlist.id}/`).reply(200, watchlist);
  });
}

export const getWatchlist = (watchlistId?: string) => {
  return api.get(`/carburate/watchlists/${watchlistId}/`) as Promise<Watchlist>;
};

export const getWatchlistQueryOptions = ({ watchlistId }: { watchlistId?: string }) => {
  return queryOptions({
    queryKey: ["watchlists", watchlistId],
    queryFn: () => getWatchlist(watchlistId),
  });
};

type UseWatchlistOptions = {
  watchlistId?: string;
  queryConfig?: QueryConfig<typeof getWatchlist>;
};

export const useWatchlist = ({ watchlistId, queryConfig }: UseWatchlistOptions) => {
  return useQuery({
    enabled: hasAccessToken() && !!watchlistId,
    ...getWatchlistQueryOptions({ watchlistId }),
    refetchOnWindowFocus: true,
    ...queryConfig,
  });
};
